/* HL FIX — hl-image-guard.js
   Capa de disuasión para las fotos de la ficha de producto (menudeo y mayoreo).
   Archivo NUEVO: no sustituye ni modifica ningún archivo de Dawn 16.0.0.
   Lo carga snippets/hl-image-guard.liquid con defer; fuera de la ficha de
   producto no se pide.

   LO QUE ESTE ARCHIVO NO PUEDE HACER:
     - No impide una captura de pantalla. El navegador no expone ninguna API para
       apagar el capturador del sistema operativo (Windows, macOS, iOS, Android),
       ni la grabación de pantalla, ni la foto del monitor con otro teléfono.
     - No impide bajar el original: la URL del CDN de Shopify es pública.
     - No detecta las herramientas de desarrollador. A propósito: las técnicas que
       circulan (medir el tamaño de la ventana, cronometrar `debugger`) fallan
       solas, castigan a clientes legítimos con la ventana acoplada y se saltan
       con una casilla del propio navegador. Un guardián que da falsos positivos
       es peor que no tener guardián.
   Detalle para el Owner: docs/mvp/PROTECCION_IMAGENES_ES.md

   NADA de librerías externas, nada de canvas, nada de base64.
*/
(function () {
  'use strict';

  var cfg = document.querySelector('.hl-guard-config');
  if (!cfg) return;

  var GUARD = cfg.getAttribute('data-guard') === '1';
  var KEYS = cfg.getAttribute('data-keys') === '1';
  var SHIELD = cfg.getAttribute('data-shield') === '1';

  /* Este archivo se vuelve a ejecutar solo. No es un caso raro, es lo normal:
     HTMLUpdateUtility.setInnerHTML (assets/global.js) re-crea las etiquetas
     <script> del HTML que inyecta, y por ahí pasan el cambio de variante
     (assets/product-info.js) y la ventana de compra rápida (assets/quick-add.js).
     Sin este registro, cada cambio de variante dejaría un escucha más colgado del
     documento. Los escuchas se enlazan UNA vez; el resto del trabajo sí se repite,
     porque los nodos que había antes ya fueron reemplazados. */
  var REG = window.__hlGuard || (window.__hlGuard = { listo: false, obs: null });

  /* Alcance: sólo el media de la ficha. El visor ampliado (<product-modal>) se
     muda a document.body en su connectedCallback, por eso el selector se evalúa
     contra el documento entero y no contra la sección. */
  var SCOPE = '.product__media-wrapper, .product-media-modal, media-gallery';

  function enAlcance(nodo) {
    return !!(nodo && nodo.closest && nodo.closest(SCOPE));
  }

  function cada(raiz, selector, fn) {
    if (!raiz || !raiz.querySelectorAll) return;
    Array.prototype.forEach.call(raiz.querySelectorAll(selector), fn);
  }

  /* ---------- §1  menú contextual y arrastre ----------
     Delegado en document para que las fotos que Dawn vuelve a pintar al cambiar
     de variante queden cubiertas sin volver a enlazar nada.
     ALCANCE REAL: estorba al clic derecho y al arrastre con el ratón. No estorba
     a «Ver código fuente», ni al panel de red, ni a pegar la URL del CDN en otra
     pestaña. Es un tope de conveniencia, no un candado. */
  if (GUARD && !REG.listo) {
    document.addEventListener(
      'contextmenu',
      function (e) {
        if (enAlcance(e.target)) e.preventDefault();
      },
      false
    );

    document.addEventListener(
      'dragstart',
      function (e) {
        if (enAlcance(e.target)) e.preventDefault();
      },
      false
    );
  }

  /* ---------- §2  atributos por imagen ----------
     draggable="false" cubre Firefox, donde -webkit-user-drag no existe.
     El listener de dragstart de arriba ya cubre el resto; esto es redundancia
     barata, no la única defensa. */
  function marcar(raiz) {
    if (!GUARD) return;
    cada(raiz, '.product__media-wrapper img, .product-media-modal img', function (img) {
      if (img.getAttribute('draggable') !== 'false') img.setAttribute('draggable', 'false');
    });
  }

  /* ---------- §3  capa transparente ----------
     Sólo cuando image_zoom = none. En lightbox y en hover, Dawn ya deja
     .product__media-toggle::after (z-index 2) encima de la foto, y meter otra
     capa ahí sólo serviría para tapar el botón que abre el visor ampliado.
     Se añade como ÚLTIMO hijo de .product__media para no alterar el primer hijo,
     del que dependen assets/magnify.js y assets/media-gallery.js. */
  function blindar(raiz) {
    if (!SHIELD) return;
    cada(raiz, '.product__media', function (media) {
      if (media.querySelector('.hl-guard__shield')) return;
      var capa = document.createElement('span');
      capa.className = 'hl-guard__shield';
      capa.setAttribute('aria-hidden', 'true');
      media.appendChild(capa);
    });
  }

  function aplicar(raiz) {
    marcar(raiz);
    blindar(raiz);
  }

  /* ---------- §4  atajos de teclado ----------
     ADVERTENCIA HONESTA, no la suavices en ninguna revisión posterior:
     esto es una barrera PSICOLÓGICA y nada más.
       - Ctrl/Cmd+S y Ctrl+U sí se pueden cancelar desde la página.
       - F12 y Ctrl/Cmd+Shift+I / J / C los atiende el navegador ANTES que la
         página en Chrome, Edge y Firefox: el preventDefault no los detiene.
       - El menú del propio navegador (tres puntos -> Más herramientas) abre las
         mismas herramientas sin pasar por el teclado.
     Se ignora cuando el foco está en un campo de texto, para no romper la
     escritura del cliente. */
  if (KEYS && !REG.listo) {
    document.addEventListener(
      'keydown',
      function (e) {
        var t = e.target;
        if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) {
          return;
        }
        var k = (e.key || '').toLowerCase();
        var mod = e.ctrlKey || e.metaKey;
        if (mod && !e.shiftKey && !e.altKey && (k === 's' || k === 'u')) {
          e.preventDefault();
          return;
        }
        if (mod && e.shiftKey && (k === 'i' || k === 'j' || k === 'c')) {
          e.preventDefault();
          return;
        }
        if (k === 'f12') e.preventDefault();
      },
      false
    );
  }

  /* ---------- §5  arranque y re-aplicación ----------
     Dawn vuelve a pintar la galería al cambiar de variante (assets/product-info.js).
     Se observan sólo dos raíces concretas —no todo el body— para no pagar un
     MutationObserver global en un catálogo que se ve casi todo en celular. */
  function arrancar() {
    aplicar(document);
    REG.listo = true;

    if (typeof MutationObserver !== 'function') return;

    /* Los nodos observados se reemplazan enteros al cambiar de variante, así que
       en cada arranque se desconecta el observador anterior y se vuelve a colgar
       de los nodos que hay ahora. Nunca queda más de un observador vivo. */
    if (REG.obs) REG.obs.disconnect();

    var pendiente = false;
    REG.obs = new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () {
        pendiente = false;
        aplicar(document);
      });
    });

    ['product-info', 'product-modal'].forEach(function (sel) {
      var raiz = document.querySelector(sel);
      if (raiz) REG.obs.observe(raiz, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, false);
  } else {
    arrancar();
  }
})();
